import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { client } from '../api';
import type { TasksResponse } from '../api';
import { PartnerTaskStatusFilter } from '../api';
import PageContainer from '../components/PageContainer';
import TasksTable from '../components/tasks/TasksTable';
import { formatTaskData } from '../components/tasks/utils';
import { Outlet, useNavigate } from 'react-router-dom';
import { tasksQueryKey } from '../queries';
import Button from 'design-system/src/components/Button/Button';

const TasksTablePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || PartnerTaskStatusFilter.OPEN; // Default to 'open' (Requires response)

  const { data, isLoading, error } = useQuery<TasksResponse>({
    queryKey: tasksQueryKey(status),
    queryFn: () =>
      client.get('/tasks', { params: { status } }).then((res) => {
        res.data.tasks = formatTaskData(res.data.tasks);
        return res.data;
      }),
  });

  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const newTaskButton = (
    <Button size="sm" onClick={() => navigate('new?source=portal_task_page')}>
      Create task
    </Button>
  );

  return (
    <>
      <PageContainer
        title="Tasks"
        subtitle="These require input from your team to move prescriptions forward."
        headerRight={newTaskButton}
      >
        <TasksTable data={data?.tasks || []} isLoading={isLoading} error={error} />
      </PageContainer>
      <Outlet
        context={{
          reload: () => queryClient.resetQueries({ queryKey: tasksQueryKey(status) }),
        }}
      />
    </>
  );
};

export default TasksTablePage;
